export const visitRecordKey = 'visitRecord';
export const visitReferRecordKey = 'visitReferRecord';
export const expireTime = 1000 * 60 * 60 * 24; // 1天
